import { useIsInExperiment } from '~/hooks/common';

export default function useIsInSoftNotifyExperiment() {
  return useIsInExperiment('vdp-soft-notify4', 'experiment');
}
